/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rulesetdescription2Inputs */

const en_entity_rulesetdescription2 = /** @type {(inputs: Entity_Rulesetdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rule Set Description`)
};

const de_entity_rulesetdescription2 = /** @type {(inputs: Entity_Rulesetdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Rule Set Description" |
*
* @param {Entity_Rulesetdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rulesetdescription2 = /** @type {((inputs?: Entity_Rulesetdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rulesetdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rulesetdescription2(inputs)
	return de_entity_rulesetdescription2(inputs)
});
export { entity_rulesetdescription2 as "entity_ruleSetDescription" }